import forResponse from '../utils/forResponse';
import { getUserDetails } from '../utils/getUserDetails';
import { LIST_ALL_EPAY_PRICES_FANCLUB } from '../constants/apiUrls/apiUrls';

import http from './http';


export const getFanclubSubscriptionPackage = (anchorId) => {
  const URL = LIST_ALL_EPAY_PRICES_FANCLUB.replace('{anchorId}', encodeURIComponent(anchorId));
  const queryParams = getUserDetails();

  return forResponse(http.get(URL, { params: queryParams, withCredentials: false }));
};
